import React, { createContext, useEffect, useState } from 'react';

const WebSocketContext = createContext(null);
const token = localStorage.getItem('token');

export const WebSocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);

  // TODO: switch ws url for production
  // const WS_URL = 'ws://localhost:3001/ws';
  const WS_URL = 'wss://api.signblast.com.au/ws';


  useEffect(() => {
    const ws = new WebSocket(`${WS_URL}?token=${token}`);
    
    ws.onopen = () => {
      console.log('WebSocket connected');
      setSocket(ws);
    };

    ws.onclose = () => {
      console.log('WebSocket disconnected');
      setSocket(null);
    };

    return () => ws.close();
  }, []);

  return (
    <WebSocketContext.Provider value={socket}>
      {children}
    </WebSocketContext.Provider>
  );
};

export const useWebSocket = () => {
  return React.useContext(WebSocketContext);
};